module.exports = __webpack_public_path__ + "img/blr.36ff239b.svg";